import React from 'react';
import { observer } from 'mobx-react';
import { action } from 'mobx';
import { FormattedMessage } from 'react-intl';
import { FormField } from '../../../../../../../global/form/form-field/form-field';
import { ICustomFieldsDTO } from '../../../../../../../../api/custom-fields.dao';
import SelectTextList from '../../../../../../../global/select-text-list/select-text-list';

interface ICustomFieldTriagedFormProps {
    getFieldErrorMessage: (text: string, isMandatory?: boolean, isAlphaNumeric?: boolean) => string;
    getTriageOptionsErrorMessage: (options: string[]) => string | null;
    setTouchFieldStatus: (fieldName: string) => void;
    field: ICustomFieldsDTO;
    isExternalFieldIDChanged: boolean;
    isLabelChanged: boolean;
    addAnswer: (value: string) => void;
    removeAnswer: (value: string) => void;
    isNewField: boolean;
}

const CustomFieldTriagedForm = observer(({
    getFieldErrorMessage,
    setTouchFieldStatus,
    field,
    isExternalFieldIDChanged,
    isLabelChanged,
    addAnswer,
    removeAnswer,
    getTriageOptionsErrorMessage,
    isNewField
}: ICustomFieldTriagedFormProps) => {

    const externalCustomFieldIdError = getFieldErrorMessage(field.externalFieldId, true, true);
    const labelCustomFieldError = getFieldErrorMessage(field.label, true);
    const descriptionFieldError = getFieldErrorMessage(field.description);
    const triageOptionsError = getTriageOptionsErrorMessage(field.optionsList);

    return (
        <>
            <FormField
                className='m-bottom-20px'
                label={<FormattedMessage
                    id='oe.label.fieldId'
                    description='Label text'
                    defaultMessage='Field ID'
                />}
            >
                <div className='flex'>
                    <input
                        id='custom-fieldID-label'
                        className='oe-form-field__control'
                        value={field.externalFieldId}
                        onBlur={() => setTouchFieldStatus('isExternalFieldIDChanged')}
                        onChange={action(e => {
                            setTouchFieldStatus('isExternalFieldIDChanged');
                            field.externalFieldId = e.target.value;
                        })}
                        type='text'
                        disabled={!isNewField}
                    />
                </div>
                {isExternalFieldIDChanged && externalCustomFieldIdError &&
                    <span className='oe-form-field__error'>
                        {<FormattedMessage
                            id='oe.label.fieldIdError'
                            description='Label text'
                            defaultMessage='Field ID {suffix}'
                            values={{
                                suffix: externalCustomFieldIdError
                            }}
                        />}
                    </span>
                }
            </FormField>


            <FormField
                className='m-bottom-20px'
                label={<FormattedMessage
                    id='oe.label.fieldLabel'
                    description='Label text'
                    defaultMessage='Field Label'
                />}
            >
                <>
                    <input
                        id='customField-label'
                        className='oe-form-field__control'
                        value={field.label}
                        onBlur={() => setTouchFieldStatus('isLabelChanged')}
                        onChange={action(e => {
                            setTouchFieldStatus('isLabelChanged');
                            field.label = e.target.value;
                        })}
                        type='text'
                    />
                    {isLabelChanged && labelCustomFieldError &&
                        <span className='oe-form-field__error'>
                            {<FormattedMessage
                                id='oe.label.fieldLabelError'
                                description='Label text'
                                defaultMessage='Field Label {suffix}'
                                values={{
                                    suffix: labelCustomFieldError
                                }}
                            />}
                        </span>
                    }
                </>
            </FormField>

            <FormField
                className='m-bottom-20px'
                label={<FormattedMessage
                    id='oe.label.fieldDescription'
                    description='Field label text'
                    defaultMessage='Description'
                />}>
                <textarea
                    className='oe-form-field__control'
                    value={field.description}
                    onChange={action(e => field.description = e.target.value)}
                />
                {descriptionFieldError &&
                    <span className='oe-form-field__error'>
                        {<FormattedMessage
                            id='oe.label.fieldDescriptionError'
                            description='Label text'
                            defaultMessage='Description {suffix}'
                            values={{
                                suffix: descriptionFieldError
                            }}
                        />}
                    </span>
                }
            </FormField>
            <SelectTextList
                label={
                    <FormattedMessage
                        description='Label text'
                        defaultMessage='Answer Options'
                        id='oe.triageQuestion.AnswerOptions'
                    />
                }
                optionsList={field.optionsList}
                addOption={addAnswer}
                removeOption={removeAnswer}
                getFieldErrorMessage={getFieldErrorMessage}
                optionsInvalidErrorMessage={triageOptionsError}
            />
        </>
    );
});

export default CustomFieldTriagedForm;
